import { Component } from '@angular/core';
import { AbstractFieldReadComponent } from '../base-field/abstract-field-read.component';
import { CaseReferencePipe } from '../../../pipes/case-reference';

@Component({
  selector: 'ccd-read-case-link-field',
  template: require('./read-case-link-field.html')
})
export class ReadCaseLinkFieldComponent extends AbstractFieldReadComponent {

  constructor(private caseReferencePipe: CaseReferencePipe) {
    super();
  }

  public hasReference(): boolean {
    return this.caseField.value && this.caseField.value.CaseReference;
  }

  public linkHref(): string {
    return `/case/${this.caseField.value.CaseReference}`;
  }

  public linkText(): string {
    return this.caseField.value.Description ||
      this.caseReferencePipe.transform(this.caseField.value.CaseReference);
  }
}
